// src/BaseIcon.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var BaseIcon = forwardRef(
  ({ size = 24, children, ...props }, ref) => {
    const svgSize = typeof size === "number" ? `${size}px` : size;
    return /* @__PURE__ */ jsx(
      "svg",
      {
        ref,
        width: svgSize,
        height: svgSize,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children
      }
    );
  }
);
BaseIcon.displayName = "BaseIcon";

export {
  BaseIcon
};
